import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ContributionUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.getContributionData(req);
    }
}
export default ContributionUseCase;
